// src/pages/TermsOfServicePage.jsx

import React from 'react';
import { FiFileText, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import './LegalPage.css';

const TermsOfServicePage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <FiFileText className="legal-icon" />
          <h1>{t('terms.title')}</h1>
          <p className="legal-date">{t('terms.lastUpdated')}: 5 de novembro de 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. {t('terms.section1.title')}</h2>
            <p>{t('terms.section1.content')}</p>
          </section>

          <section className="legal-section">
            <h2>2. {t('terms.section2.title')}</h2>
            <p>{t('terms.section2.intro')}</p>
            <ul>
              <li>{t('terms.section2.item1')}</li>
              <li>{t('terms.section2.item2')}</li>
              <li>{t('terms.section2.item3')}</li>
              <li>{t('terms.section2.item4')}</li>
              <li>{t('terms.section2.item5')}</li>
            </ul>

            <h3>2.1 Programa "Treinadores Fundadores" (Versão Beta)</h3>
            <p>
              Você compreende e concorda que o Serviço está sendo fornecido a você como parte de um programa "Beta" 
              (doravante "Programa de Fundadores") e constitui uma versão de pré-lançamento do nosso software. 
              O propósito deste programa é obter feedback sobre o desempenho do Serviço.
            </p>
            <p>
              Como tal, o Serviço é considerado "software em desenvolvimento" e é fornecido "COMO ESTÁ" ("AS-IS") 
              e "CONFORME DISPONÍVEL" ("AS-AVAILABLE"). O Serviço pode conter bugs, erros, falhas ou interrupções 
              e pode não operar de forma tão confiável ou completa quanto uma versão comercial final. O Podium não 
              oferece nenhuma garantia, expressa ou implícita, de que o Serviço será ininterrupto, livre de erros, 
              ou que atenderá integralmente às suas necessidades.
            </p>
            <p>
              Como participante do Programa de Fundadores, sua opinião é fundamental. Você concorda que qualquer 
              feedback, sugestão, ideia ou comentário que você fornecer sobre o Serviço ("Feedback") é fornecido 
              voluntariamente. Ao enviar o Feedback, você nos concede uma licença perpétua, irrevogável, mundial, 
              não exclusiva e isenta de royalties para usar, reproduzir, modificar, adaptar, publicar e incorporar 
              tal Feedback em nossos produtos e serviços atuais ou futuros, sem qualquer obrigação de compensação 
              ou atribuição a você.
            </p>
            <p>
              O Podium reserva-se o direito de modificar, suspender ou descontinuar o Programa de Fundadores, 
              ou qualquer funcionalidade do Serviço, a qualquer momento e a nosso exclusivo critério, com ou sem 
              aviso prévio.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. {t('terms.section3.title')}</h2>
            
            <h3>3.1 {t('terms.section3.sub1.title')}</h3>
            <p>{t('terms.section3.sub1.content')}</p>

            <h3>3.2 {t('terms.section3.sub2.title')}</h3>
            <ul>
              <li>{t('terms.section3.sub2.item1')}</li>
              <li>{t('terms.section3.sub2.item2')}</li>
              <li>{t('terms.section3.sub2.item3')}</li>
              <li>{t('terms.section3.sub2.item4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. {t('terms.section4.title')}</h2>
            
            <h3>4.1 {t('terms.section4.sub1.title')}</h3>
            <p>{t('terms.section4.sub1.content')}</p>

            <h3>4.2 {t('terms.section4.sub2.title')}</h3>
            <p>
              {t('terms.section4.sub2.content')} 
              <a href="https://www.strava.com/legal/api" target="_blank" rel="noopener noreferrer"> {t('terms.section4.sub2.link')}</a>. 
              {t('terms.section4.sub2.content2')}
            </p>

            <h3>4.3 {t('terms.section4.sub3.title')}</h3>
            <p>{t('terms.section4.sub3.content')}</p>
          </section>

          <section className="legal-section">
            <h2>5. {t('terms.section5.title')}</h2>
            
            <div className="info-box success">
              <FiCheckCircle />
              <p><strong>{t('terms.section5.can.title')}</strong></p>
              <ul>
                <li>{t('terms.section5.can.item1')}</li>
                <li>{t('terms.section5.can.item2')}</li>
                <li>{t('terms.section5.can.item3')}</li>
              </ul>
            </div>

            <div className="info-box warning">
              <FiAlertCircle />
              <p><strong>{t('terms.section5.cannot.title')}</strong></p>
              <ul>
                <li>{t('terms.section5.cannot.item1')}</li>
                <li>{t('terms.section5.cannot.item2')}</li>
                <li>{t('terms.section5.cannot.item3')}</li>
                <li>{t('terms.section5.cannot.item4')}</li>
                <li>{t('terms.section5.cannot.item5')}</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>6. {t('terms.section6.title')}</h2>
            <p>{t('terms.section6.content')}</p>

            <h3>6.1 {t('terms.section6.sub1.title')}</h3>
            <p>{t('terms.section6.sub1.content')}</p>
          </section>

          <section className="legal-section">
            <h2>7. {t('terms.section7.title')}</h2>
            
            <div className="warning-box">
              <FiAlertCircle />
              <p>
                <strong>{t('terms.section7.medical.title')}</strong> {t('terms.section7.medical.content')}
              </p>
            </div>

            <p>{t('terms.section7.content')}</p>
          </section>

          <section className="legal-section">
            <h2>8. {t('terms.section8.title')}</h2>
            <p>{t('terms.section8.intro')}</p>
            <ul>
              <li>{t('terms.section8.item1')}</li>
              <li>{t('terms.section8.item2')}</li>
              <li>{t('terms.section8.item3')}</li>
              <li>{t('terms.section8.item4')}</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. {t('terms.section9.title')}</h2>
            <p>{t('terms.section9.content')}</p>
          </section>

          <section className="legal-section">
            <h2>10. {t('terms.section10.title')}</h2>
            <p>{t('terms.section10.content')}</p>
          </section>

          <section className="legal-section">
            <h2>11. {t('terms.section11.title')}</h2>
            <p>{t('terms.section11.content')}</p>
          </section>

          <section className="legal-section">
            <h2>12. {t('terms.section12.title')}</h2>
            <p>{t('terms.section12.content')}</p>
          </section>

          <section className="legal-section">
            <h2>13. {t('terms.section13.title')}</h2>
            <p>{t('terms.section13.intro')}</p>
            <div className="contact-box">
              {/*<p><strong>{t('terms.section13.email')}:</strong> legal@podiumrun.com</p>*/}
              <p><strong>{t('terms.section13.support')}:</strong> support@podiumrun.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
